module Meevo.Plugins.Transworld {

    export interface ITranswolrdSettings {
        clientNumber?: number;
        dontSendPastDueClients?: boolean;
        dontSendPastDueClientsDaysLimit?: number;
        enableTransworld?: boolean;
        sendClientWhenPastDue?: boolean;
        sendClientWhenPastDueAmount?: boolean;
        sendClientWhenPastDueAmountLimit?: number;
        sendClientWhenPastDueDaysLimit?: number;
    }

    interface ITransworldService {
        updateSettings(transwolrdSettings: ITranswolrdSettings): angular.IPromise<any>;
    }

    export class TransworldService implements ITransworldService {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.tracking.TrackingService'
        ];

        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected trackingService: Meevo.Components.Tracking.ITrackingService
        ) { }

        /**
         * Update transworld settings
         * @param {ITranswolrdSettings} transwolrdSettings
         * @returns {ng.IPromise<ITranswolrdSettings>} promise
         */
        updateSettings(transwolrdSettings: ITranswolrdSettings): ng.IPromise<ITranswolrdSettings> {
            return this.dataService.update(this.appSettings.API_ENDPOINTS.transworld, transwolrdSettings);
        }

    }

    angular.module('meevo.plugins.transworld')
        .service('meevo.plugins.transworld.transworldService', TransworldService);
}